<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <!-- Overlapping icon -->
    <div class="flex justify-center -mt-12 mb-2">
      <div class="bg-primary rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white">
        <i class="bx bx-badge-check text-white text-4xl"></i>
      </div>
    </div>
    <!-- Card content -->
    <div class="px-6">
      <h2 class="text-2xl font-bold text-center mb-1">Inserisci il codice</h2>
      <p class="text-gray-500 text-center mb-4">Inserisci il codice ricevuto via SMS</p>
      <div class="flex justify-center gap-3 mb-4">
        <input
          v-for="(digit, idx) in codeDigits"
          :key="idx"
          ref="codeInputs"
          type="tel"
          maxlength="1"
          class="w-14 h-14 rounded-full border-2 border-gray-200 text-2xl text-center font-bold focus:outline-none focus:border-primary transition"
          v-model="code[idx]"
          @input="onInput(idx, $event)"
          @keydown.backspace="onBackspace(idx, $event)"
        />
      </div>
      <div v-if="error" class="text-red-500 text-sm mt-2 text-center">
        {{ error }}
      </div>
      <!-- Resend Button Row -->
      <div class="flex items-center justify-between mb-2">
        <span class="text-gray-400 text-xs">Richiedi di nuovo tra</span>
        <CuButton
          v-if="timer > 0"
          small
          :disabled="true"
        >
          {{ timerDisplay }}
        </CuButton>
        <CuButton
          v-else
          small
          primary
          @click="onResendClick"
        >
          Richiedi
        </CuButton>
      </div>
      <div v-if="resendSuccess" class="text-green-600 text-xs mb-2 text-center transition-opacity duration-300">
        Codice inviato con successo
      </div>
      <div class="flex gap-3 mt-4">
        <CuButton dark class="flex-1" @click="$emit('close')">Annulla</CuButton>
        <CuButton primary class="flex-1" :disabled="!isComplete" @click="confirm">Conferma</CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "PhoneCodeSheet",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false },
    error: { type: String, default: null },
    resendSuccess: { type: Boolean, default: false }
  },
  data() {
    return {
      code: ['', '', '', ''],
      timer: 203 // 3:23 in seconds
    }
  },
  computed: {
    codeDigits() {
      return [0, 1, 2, 3]
    },
    isComplete() {
      return this.code.every(d => d && d.length === 1)
    },
    timerDisplay() {
      const m = Math.floor(this.timer / 60).toString().padStart(2, '0')
      const s = (this.timer % 60).toString().padStart(2, '0')
      return `${m}:${s}`
    }
  },
  watch: {
    show(val) {
      if (val) this.startTimer()
    },
    error(newVal) {
      if (newVal) {
        this.code = ['', '', '', '']
        // Optionally, focus the first input
        this.$nextTick(() => {
          if (this.$refs.codeInputs && this.$refs.codeInputs[0]) {
            this.$refs.codeInputs[0].focus()
          }
        })
      }
    }
  },
  methods: {
    onInput(idx, e) {
      const val = e.target.value.replace(/[^0-9]/g, '')
      this.$set(this.code, idx, val)
      if (val && idx < 3) {
        this.$refs.codeInputs[idx + 1].focus()
      }
    },
    onBackspace(idx) {
      if (!this.code[idx] && idx > 0) {
        this.$refs.codeInputs[idx - 1].focus()
      }
    },
    confirm() {
      this.$emit('confirm', this.code.join(''))
    },
    startTimer() {
      this.timer = 300
      if (this._timerInterval) clearInterval(this._timerInterval)
      this._timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          clearInterval(this._timerInterval)
        }
      }, 1000)
    },
    onResendClick() {
      this.$emit('resend')
      this.startTimer()
    }
  },
  beforeDestroy() {
    if (this._timerInterval) clearInterval(this._timerInterval)
  }
}
</script>
